
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/newsletters",
      function () {
        return require("private-next-pages/newsletters/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/newsletters"])
      });
    }
  